module.exports = __webpack_public_path__ + "static/media/sandglass-small.e9c4d386.png";